import { Grid, MenuItem } from '@mui/material';
import React, { FC, useState } from 'react';
import {
  SMBSelect,
  NeighborhoodDropdown,
  NeighborhoodLotsDropdown,
  FiltersButtons,
  FiltersLayout
} from '../../../components';
import { IOrderStatus, IPeople } from '../../../models';

interface IManageSpecFilters {
  isLoadingAgents: boolean;
  selectedAgent: string;
  setSelectedAgent: (val: string) => void;
  agents: IPeople[] | null;
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  selectedStatus: string;
  setSelectedStatus: (val: string) => void;
  handleSearch: (clearSearch?: boolean) => void;
  statuses: IOrderStatus[] | null;
  selectedLotId: string;
  isLoadingStatuses: boolean;
  setSelectedNeighborhoodId: (val: any) => void;
  setSelectedLotId: (val: any) => void;
  selectedNeighborhoodId: string;
}

export const ManageSpecFilters: FC<IManageSpecFilters> = ({
  isLoading,
  applyFilters,
  selectedStatus,
  setSelectedStatus,
  selectedNeighborhoodId,
  selectedLotId,
  setSelectedNeighborhoodId,
  setSelectedLotId,
  statuses,
  isLoadingStatuses,
  isLoadingAgents,
  agents,
  selectedAgent,
  setSelectedAgent
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={3}>
        <NeighborhoodDropdown
          value={selectedNeighborhoodId}
          handleChange={value => {
            setSelectedNeighborhoodId(value);
          }}
          isAdminPortal={true}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <NeighborhoodLotsDropdown
          value={selectedLotId}
          isDisabled={!selectedNeighborhoodId}
          handleChange={value => setSelectedLotId(value)}
          apiParams={{ neighborhoodId: selectedNeighborhoodId }}
          isAdminPortal={true}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SMBSelect
          label="Phase"
          variant="outlined"
          disabled={isLoadingStatuses}
          name="status"
          handleClear={() => setSelectedStatus('')}
          id="status"
          value={selectedStatus}
          onChange={({ target: { value } }) => setSelectedStatus(value as string)}
        >
          {statuses &&
            statuses.map((status, index) => {
              return (
                <MenuItem key={`${index}`} value={status.value}>
                  {status.description}
                </MenuItem>
              );
            })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SMBSelect
          disabled={isLoadingAgents}
          name="agent"
          label="Agent"
          id="agent"
          variant="outlined"
          handleClear={() => setSelectedAgent('')}
          value={selectedAgent}
          onChange={({ target: { value } }) => setSelectedAgent(value as string)}
        >
          {agents &&
            agents.map((agent, index) => {
              return (
                <MenuItem key={`${index}`} value={agent.personId}>
                  {agent.firstName} {agent.lastName}
                </MenuItem>
              );
            })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} md={5}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedNeighborhoodId('');
            setSelectedLotId('');
            setSelectedStatus('');
            setSelectedStatus('');
            setSelectedAgent('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
